import type { IconSvgObject } from './types';

const OpenCaptionIcon: IconSvgObject = [
  ["path", { d: "M22 16V5C22 3.89543 21.1046 3 20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 7.5H8C7.44772 7.5 7 7.94772 7 8.5V12.5C7 13.0523 7.44772 13.5 8 13.5H10.5M17 7.5H14.5C13.9477 7.5 13.5 7.94772 13.5 8.5V12.5C13.5 13.0523 13.9477 13.5 14.5 13.5H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 21H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default OpenCaptionIcon;
